import { Alert, Button, PageLoader } from '@alicerce/ui';
import { useMutation } from '@tanstack/react-query';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { errorMessage } from '@/lib/api';
import { useSession } from '@/lib/session';
import { AuthLayout } from './layout';

/** Link do e-mail de convite: quem já está logado aceita; quem não está entra ou cria conta e volta aqui. */
export function AcceptInvitePage() {
  const { status, api, me, selectTenant, refreshMe } = useSession();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const here = `/convite?token=${encodeURIComponent(token)}`;
  const accept = useMutation({
    mutationFn: () => api.post<{ tenantId: string }>('/v1/core/invites/accept', { token }, { noTenant: true }),
    onSuccess: async (r) => {
      await refreshMe();
      selectTenant(r.tenantId);
      navigate('/', { replace: true });
    },
  });

  if (status === 'loading') return <PageLoader />;
  return (
    <AuthLayout title="Convite para a equipe">
      {status === 'anonymous' ? (
        <div className="space-y-3">
          <p className="text-sm">Entre com o e-mail que recebeu o convite, ou crie sua conta com ele.</p>
          <div className="flex gap-2">
            <Link className="inline-flex h-10 flex-1 items-center justify-center rounded-lg bg-brand-600 text-sm font-medium text-white" to={`/entrar?next=${encodeURIComponent(here)}`}>
              Entrar
            </Link>
            <Link className="inline-flex h-10 flex-1 items-center justify-center rounded-lg border border-line text-sm font-medium" to={`/criar-conta?next=${encodeURIComponent(here)}`}>
              Criar conta
            </Link>
          </div>
        </div>
      ) : (
        <div className="space-y-3">
          <p className="text-sm">
            Você vai entrar na equipe com o e-mail <strong>{me?.user.email}</strong>.
          </p>
          {accept.isError && <Alert tone="danger">{errorMessage(accept.error)}</Alert>}
          <Button className="w-full" loading={accept.isPending} onClick={() => accept.mutate()}>
            Aceitar convite
          </Button>
        </div>
      )}
    </AuthLayout>
  );
}
